import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { HeaderComponent } from './header/header.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { SideMenuComponent } from './side-menu/side-menu.component';

import { LoginComponent } from './login/login.component';
import { AuthenticationGuard } from './authentication.guard';
import { PopupComponent } from './popup/popup.component';
import { ViewsComponent } from './views/views.component';

import { SessionexpiredComponent } from './views/sessionexpired/sessionexpired/sessionexpired.component';



const routes: Routes = [

    { path: '', redirectTo: "/login", pathMatch: 'full' },
    { path: 'login', component: LoginComponent },

    //{
    //    path: 'views',
    //    loadChildren: () => import('./views/views.component').then(m => m.ViewsComponent)
    //},
    {
        path: 'views', component: ViewsComponent, canActivate: [AuthenticationGuard],

        children: [
            { path: 'sessionexpired', component: SessionexpiredComponent },

        ]

    },

];

@NgModule({
    declarations: [],
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
